export default function getScaledLevel(
  analyser: AnalyserNode,
  opts?: {
    bandMinHz?: number; // 주파수 대역 - 기본 250
    bandMaxHz?: number; // 주파수 대역 - 기본 min(3400, Nyquist-1)
    outMin?: number; // 결과값 범위 - 기본 0.5
    outMax?: number; // 결과값 범위 - 기본 2.0
    clipThreshold?: number; // 기본 0.9997 (시간영역 절대값 기준)
    flatRun?: number; // 기본 10 (flat-top 감지 연속 샘플 수)
  }
): number {
  const {
    bandMinHz = 250,
    bandMaxHz = Math.min(3400, analyser.context.sampleRate / 2 - 1),
    outMin = 0.5,
    outMax = 2.0,
    clipThreshold = 0.9997,
    flatRun = 10,
  } = opts ?? {};

  const bins = analyser.frequencyBinCount;
  const dbArray = new Float32Array(bins);
  analyser.getFloatFrequencyData(dbArray);

  const sr = analyser.context.sampleRate;
  const binHz = sr / (2 * bins);
  const startBin = Math.max(0, Math.floor(bandMinHz / binHz));
  const endBin = Math.min(bins, Math.ceil(bandMaxHz / binHz));

  // ---------- FREQ: 평균 파워 기반 RMS 근사 ----------
  let powerSum = 0;
  let count = 0;

  for (let i = startBin; i < endBin; i++) {
    // dB -> 선형 파워 변환 (dB는 파워 기준이므로 10 log10 사용)
    const p = Math.pow(10, dbArray[i] / 10);
    if (Number.isFinite(p)) {
      powerSum += p;
      count++;
    }
  }

  const meanPower = count > 0 ? powerSum / count : 0;
  const dbfsApprox = 10 * Math.log10(meanPower + 1e-20);

  // analyser의 min/max dB 구간을 0..1로 정규화
  const minDb = analyser.minDecibels; // 예: -100
  const maxDb = analyser.maxDecibels; // 예: -30
  let t = (dbfsApprox - minDb) / (maxDb - minDb);
  t = Math.min(Math.max(t, 0), 1);

  // 원하는 출력 구간으로 매핑
  let scaled = outMin + (outMax - outMin) * t;

  // ---------- TIME: 클리핑 가드 ----------
  const fftSize = analyser.fftSize;
  const timeData = new Float32Array(fftSize);
  analyser.getFloatTimeDomainData(timeData); // [-1..1]

  let run = 0;
  let clipped = false;

  for (let i = 0; i < fftSize; i++) {
    const v = Math.abs(timeData[i]);
    if (v >= clipThreshold) {
      clipped = true;
      break;
    }
    if (v >= 0.98) {
      if (++run >= flatRun) {
        clipped = true;
        break;
      }
    } else {
      run = 0;
    }
  }

  if (clipped) scaled = outMax;

  // let currentMin = Infinity;
  // let currentMax = -Infinity;
  //
  // for (let i = 0; i < dbArray.length; i++) {
  //   if (dbArray[i] > currentMax) currentMax = dbArray[i];
  //   if (dbArray[i] < currentMin) currentMin = dbArray[i];
  // }
  // const currentMid = (currentMax + currentMin) / 2;
  // console.log('[DECIBELS]', 'Min:', currentMin, 'Mid:', currentMid, 'Max:', currentMax);
  return scaled;
}
